var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"w-4/5 mx-auto"},[(_vm.one === null)?_c('DoneCleaning',{attrs:{"to":`/survey/${_vm.surveyID}`}}):_c('CompareComponent',{attrs:{"id":_vm.surveyID,"one":_vm.one,"two":_vm.two,"surveyID":_vm.surveyID}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }